import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_CUSTOMER_BY_ID_QUERY_KEY } from './useGetCustomerById';
import { GET_CUSTOMERS_INFO_KEY } from './useGetCustomersInfo';

import CustomerService, {
  UpdateCustomerInfoDto,
} from '@/services/CustomerService';

export function useUpdateCustomer(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: UpdateCustomerInfoDto) =>
      CustomerService.updateCustomer(data),
    onSuccess: (updatedCustomer, variables) => {
      const customerId = updatedCustomer?.id ?? variables.id;

      queryClient.invalidateQueries({
        queryKey: GET_CUSTOMER_BY_ID_QUERY_KEY(customerId),
      });

      queryClient.invalidateQueries({
        queryKey: ['paginated-customers'],
        exact: false,
      });

      queryClient.invalidateQueries({ queryKey: GET_CUSTOMERS_INFO_KEY });

      onSuccess?.();
    },
  });

  return {
    updateCustomer: mutateAsync,
    isLoading: isPending,
  };
}
